import React, { useEffect, useState } from "react";
import "../../../../src/App.css";
import { useNavigate } from "react-router-dom";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import WebinarCountdown from "./webinarCountDown";
import { useLocation } from "react-router-dom";
import { LazyImageComponent } from "../../CustomComponent/lazy_loading_image";
import fridayWebinar from "../../certificates/fridayWebinar.png";
import saturdayWebinar from "../../certificates/saturdayWebinar.png";
import sundayWebinar from "../../certificates/sundayWebinar.png";
import webinarPrice from "../../certificates/webinarPrice.png";
import webinarDiscount from "../../certificates/webinarDiscount.png";
import { DateTime } from "luxon";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
const userArray = [
  "Sarvjit Choubey",
  "Rajasekaran",
  "Sarvesh Kothari",
  "Nukala Shreekruthi",
  "shivank",
  "altaf",
  "Gorav Singh rathore",
  "KRISHAN GOPAL",
  "Vishal",
  "Anirudh Sharma",
  "Rishu Vasistha",
  "Vijay Pagad",
  "YASH SHAH",
  "Vinod Kumar Singh",
  "Mayank Maheshwari",
  "Sandip shivaji tare",
  "PRATHAM",
  "Aishwarya Naidu",
  "Arpit singh",
  "Prajwal Gavali",
  "zafar iqbal hussain",
  "Suhas Narasimhan N",
  "Jeffin George",
  "Ram Prakash",
  "Rajeev Bhagwat",
  "Bhavana",
  "Sameer Shukla",
  "sravan kumar",
  "Himanshu soni",
  "Ramyaa Iyer",
  "Aditya KHANDELWAL",
  "Ashok Bansal",
  "Nishchay khalasi",
  "Santosh Kumar",
  "Manali",
  "Baljeet Singh",
  "Ishan",
  "Shlok agrawal",
  "V",
  "RAKESH JAIN",
  "Chirag Pansuriya",
  "Varadan",
  "Tushar Bagda",
  "Lyventer",
  "Ch Shivnath Singh Shandilya PG College Machhra Meerut",
  "Muneesh",
  "Garwita Prakash",
  "VIKAS",
  "Sanchita",
  "OM PRAKASH SHARMA",
  "Ajeet yadav",
  "Milind Dwarkanath Deshpande",
  "M. Yadav",
  "Subodh Verma",
  "YASH VARDHAN KUSHWAHA",
  "Arijit Sil",
  "Bharani",
  "Om Sharma",
  "satisfaction",
  "Asif Dabir",
  "Uday Makasana",
  "Kabil",
  "Muhammed Nihal v p",
  "veeramani",
  "V k rana",
  "Gargi",
  "Tanmay Sharma",
  "Deepu",
  "Ashish Choudhary",
  "Gururaj Wali",
  "Sanjana",
  "Shaurya Mantri",
  "satish chaudhari",
  "Ashwin g shanbhag",
  "Chandan Das",
  "sunny",
  "anu",
  "Rajesh Waghchaware",
  "Nand Kishoer",
  "rajiv",
  "Jainendra",
  "Jitendra Jodha",
  "rishabh bhandari",
  "Gaurav Kalsait",
  "Rudraksh B",
  "Swapnil Rawat",
  "Asit Biswas",
  "Prabhav",
  "Mahesh Deshpande",
  "Pratik",
  "Saurav Upadhyay",
  "Kiran jagdale",
  ".bidisha",
  "Surendra D",
  "Jeetendra Sonpipare",
  "Alamkhan",
  "Shreyas",
  "Prashun sharma",
  "Piyush",
  "Ankit Sathvara",
  "Shagun Kashyap",
  "Mahadev Prasad",
  "Swarnabh Das",
  "Rachit Rastogi",
  "Neerav",
  "Rajesh Kumar",
  "Manjeet Gunjan",
  "vivek kadam",
  "Gaurav Karwa",
  "AJK",
  "Md Sameer Ansari",
  "Aslam Khan",
  "Ravindra kalpi",
  "Pallab Hazarika",
  "nilesh palsule",
  "Shiva",
  "Prashant Banashetti",
  "Brijesh",
  "Karteek Raghu",
  "Hariprasad majakkar",
  "VIKRANT CHARDE",
  "Raj",
  "Pulkit Chawla",
  "Shivanshu Tambe",
  "Sagar Singh Lamba",
  "rahul dmello",
  "ADITYA HULAWALE",
  "Sunit Tyagi",
  "Yashaswa Singh",
  "Hardik",
  "Ajay kumar",
  "Sourav sharma",
  "vinob nambiar",
  "Murtuza",
  "Sachdev Chauhan",
  "Santos",
  "Ashwarya rastogi",
  "Ajay jain",
  "Jog Parkash Singh",
  "Vibhuti Mangal",
  "Akshay Srivastava",
  "Vishal Naik",
  "Manneela Babavali",
  "surya",
  "Pranav",
  "Rithish",
  "Pramod Sidram Hakke",
  "Sarvaiya Dhruvik",
  "BHUWNESHWARI",
  "Swapnil Khalate",
  "Aakash",
  "Abhinav Murali",
  "PREETHI MOHAN RAO",
  "Manish",
  "Rahul Parerao",
  "Siddharthan R",
  "VIKRAM P TARE",
  "Raghuram",
  "Ritik Uppal",
  "Aditi Gawali",
  "Mayur Shinde",
  "Vijay shivale",
  "Tushar",
  "Yuvasree T",
  "Shreejit Sawant",
  "Vikram Bankar",
  "MR SANJAY DEORAM KHARAT",
  "Shreya Salunkhe",
  "Prashant Sharma",
  "Mandeep Singh",
  "Gothi",
  "Narpat sant",
  "Khushal",
  "K",
  "Priya",
  "Lohit",
  "Seetharaman KV",
  "Shankar Dhonnar",
  "Sachi darbar",
  "mohammedkaif mulla",
  "Deepak  Naik",
  "Sanjay Karwa",
  "Sanjeevkumar Anilkumar Jaganure",
  "Abhinav GUPTA",
  "Safwan Hashmi",
  "PRASHANT SEHRA",
  "Nirav Patel",
  "Sachin Tendulkar",
  "Gandhar Jain",
  "Kashish aggarwal",
  "Subham Mishra",
  "Pankaj Singh",
  "Pankaj Chaudhary",
  "Yatendra Kumar",
  "Sanaka mohan Kumar",
  "Ashish",
  "shourve sharma",
  "Utkarsh Rai",
  "Gulshan Taneja",
  "MEDIBOYINA VINAY KUMAR",
  "Pravin vishwakarma",
  "Himanshu Sangtani",
  "dineshbabu",
  "Raghu S P",
  "Manas Kumar Panigrahi",
  "Sunita Hirawat",
  "Sunil Patwa",
  "Rakesh Rathi",
  "Paras",
  "Harsh Kumar",
  "Avdesh kumar",
  "Akshay doshi",
  "Arun gupta",
  "Shyam",
  "Rajen",
  "Pura",
  "Ronak",
  "Sajid sakhidas",
  "Sunil kumar",
  "R k Gupta",
  "Gaurav munndra",
  "Satish dafda",
  "DC Jain",
  "Sonup Kumar Bhuyan",
  "Anand Ostwal",
  "Jaideep",
  "Siddhant Satya",
  "Nitesh Mishra",
  "Ratnesh Kumar Singh",
  "Raghav kapoor",
  "Nikhil Gupta",
  "Shoaib",
  "santosh kumbar",
  "Sourav Verma",
  "saurav",
  "Ajay Ram",
  "Vasant",
  "Amit Lakra",
  "Akshay Tapkir",
  "Achyut Narayan Kesari",
  "Milind Toraskar",
  "Bhushan",
  "AJAY SINGH SISODIYA",
  "Arun Batra",
  "Ajay Das",
  "Mahesh Kinekar",
  "Preetinder Singh",
  "Sumantha Sukhdeve",
  "Mahak Gehani",
  "Deepak Jadav",
  "Nilesh chopda",
  "Yash Bachhawat",
  "Sanjay Jain",
  "Aazim",
  "nihar",
  "Vraj Patel",
  "RAHUL VINAY KUMAR",
  "Utkarsh Agrawal",
  "Abhinav Mittal",
  "hitarth",
  "Sanchit Agrawal",
  "hemanth v",
  "Raja Sekhara Reddy Kaluri",
  "Pradeep Jain",
  "Aditya Dhamecha",
  "Mohammed Aleemuddin",
  "Bibhu Kumar",
  "Alok Kumar",
  "Shubham patni",
  "Soumitra Chakraborty",
  "Jayesh Abichandani",
  "Thambidhurai",
  "Mukul aggarwal",
  "Kamaljeet Saluja",
  "Kapil aggarwal",
  "Ishan Jha",
  "Harshit Agarwal",
  "Akansha gonekar",
  "Pawan Kumar Vishwakarma",
  "Urvish Bhanushali",
  "Arun S",
  "shreya barsaiyan",
  "Pankaj Arora",
  "Peeyush batra",
  "Vishal agarwal",
  "G Mahesh",
  "Anmol",
  "MOHAMED SAIFUDDIN F",
  "Mayank Gupta",
  "Monil Shah",
  "RAHULKUMAR RUPARELIYA",
  "Varun aggarwal",
  "Vaibhav Agarwal",
  "Dhavan",
  "Nilesh singh Chauhan",
  "Kushal more",
  "Parimal",
  "Ayaz Ahmad",
  "Shekhar Agarwal",
  "Harsh Bhoge",
  "Vrushali",
  "Kunal jha",
  "Sahodar kumar",
  "Ganesh Tandale",
  "Siddharth Bafna",
  "PRATIK KITTURE",
  "Krishnakumar Kabra",
  "Mr Tarsem Singh",
  "Ankur Chachra",
  "Ritesh Kumar",
  "Balish Choukimath",
  "Rana",
  "Mohit Jindal",
  "kedar",
  "Shubham Mittal",
  "Sridharan",
  "Pratik pawar",
  "Aadit Ghelani",
  "Nirmal Patel",
  "HUSAINI",
  "Vinay Garg",
  "Sourav",
  "Sam Samara",
  "Amit Kumar Dhal Samant",
  "swapnil dwivedi",
  "Dr Anil Ingulkar",
  "kunzang Dolma",
  "Gurlal Singh",
  "Gurlal Gill",
  "Chinmay Laddha",
  "Lingayas Vidyapeeth",
  "Ankush Aggarwal",
  "Sushil Sethi",
  "Madhumati",
  "Iqrah Hussain Shah",
  "MAHENDRASINGH JORAVARSINGH DAHIYA",
  "Nelson Dsouza",
  "Neelesh Gangwar",
  "Harsh Banafer",
  "Mihir",
  "Kalaria  Keshavbhai  Mepabhai",
  "Nikunj goel",
  "Aditya patro",
  "Nishant Singh",
  "Shubham",
  "Pranay kapoor",
  "Nilesh Sharma",
  "Vinay gupta",
  "Dr Shankar kumar jha",
  "Ravikumar warad",
  "Awdesh singh Shekhawat",
  "Ankita Gupta",
  "Adarsh Agrawal",
  "Pansambal Pratik Sudhakar",
  "Harshit Gupta",
  "Mohd Mehdi Akbar",
  "Chiranth",
  "Jignesh oza",
  "Ashish Jain",
  "Sachin Sambe",
  "Arushi Bhansali",
  "robin bisht",
  "Vibhash",
  "Skyadav",
  "Sajal Agarwal",
  "Samir Kukar",
  "Utkarsh Saraswat",
  "Amit Atul Chiddarwar",
  "Naveen Jain",
  "Dhruv",
  "yagnesh",
  "dharmendra kumar",
  "Pratik T Gareja",
  "Yash",
  "Sudipta Shankar Hazarika",
  "SkRabiul Islam",
  "Jatin Singla",
  "Dineshkumar Soni",
  "Ashish Gupta",
  "Krishna",
  "Rizwan Abdullah",
  "Mahesh",
  "Mohmmadali",
  "Navdeep Khanna",
  "Yuvi",
  "Hamza",
  "Prem Mehra",
  "Mayank Rathee",
  "Nishit Sahajramani",
  "SANTOSH PRAKASH UBALE",
  "Deepak Shukla",
  "Namit Jain",
  "Krishna Nand Yadav",
  "Ravi Saini",
  "Ayush jindal",
  "Benu saha",
  "Debendra Nath Podh",
  "Pretesh Suri",
  "Ddd",
  "Kedar Dawalbhakta",
  "Shobhit srivastava",
  "Shiv",
  "Samarth Handa",
  "Mehul khatri",
  "Saurabh Rajput",
  "Mohit Agrawal",
  "Anand Kumar Srivastava",
  "BHARAT JAIN",
  "AKSHEY JAIN",
  "Umesh Godara",
  "Bharat Agarwal",
  "Hemant Thakur",
  "vasu",
  "Tejash Patel",
  "Plaban",
  "Chirag Manani",
  "mayur goyal",
  "Aditya Karbhari",
  "Hanamant Jadhav",
  "Meghraj",
  "Priyanshu",
  "Vikas Bharti",
  "Chinmay Velankar",
  "Shashank  Yadav",
  "prashant kadam",
  "Hardik Jadav",
  "Praveen Rajpurohit",
  "Sonu Malik",
  "Mahesh Gupta",
  "Bharat Rathi",
  "Satya Ranjan Kabi",
  "Gaurav Nayyar",
  "Mihir Chhatrala",
  "Piyush Kumar Singh",
  "Mitesh vora",
  "Sudhir Mane",
  "Arpit MITTAL",
  "Surjit Sahu",
  "Harpeet  Sablok",
  "Amit Arya",
  "Navdeep Kahlon",
  "Shahrukh",
  "Amar kumar",
  "Akash Sancheti",
  "Sudheer",
  "Resham Lal",
  "Akkashh Gunte",
  "Sammed Neminath Girmal",
  "Shivanand B",
  "Sujeet",
  "Zariyab",
  "Ashish sharma",
  "Amit Dembani",
  "Digvijay Nagare",
  "Pinal Goti",
  "RAJIB BISWAS",
  "Akshay Moglewar",
  "Qasim Shareef",
  "Pravin singh",
  "Tanay kharbanda",
  "Jitendra Farkade",
  "PEEYUSH KHANDKA",
  "Anant Yuvraj",
  "Susant Kumar Sahoo",
  "Nishant Singh Kalakoti",
  "Vinod Jashnani",
  "Arun Patil",
  "sandipanbiswas",
  "Sanjay Ambawane",
  "Rao Sahab",
  "Rajani",
  "Aayush Mittal",
  "Nikhil Choudhury",
  "Saheel",
  "Sarvesh",
  "Sanjay Agarwal",
  "Harsh Deep Gupta",
  "HUSEN",
  "Divya baranwal",
  "Shaik",
  "Sandesh",
  "Narsing Chippa",
  "Anirudh Raghuwanshi",
  "Niraj Khattri",
  "Shridhar Bhutada",
  "Sagar nahar",
  "Neha Nigam",
  "ankur mudgal",
  "Neeraj Keswani",
  "Anant Mittal",
  "Jobanbir Singh",
  "Kshitij Mohan",
  "Tanmay Mahajan",
  "Aman Modi",
  "Vijay Kale",
  "Ravindra Sathe",
  "Azaruddin",
  "Sunil",
  "Nityagopal Saha",
  "PRAVIN LOKHANDE",
  "Prince Jha",
  "Suresh",
  "Sikandar Ramteke",
  "Rajdeep",
  "Rishi",
  "Nadeem Ahmed",
  "Shrinivas Patil",
  "Seema Sinha Prasad",
  "Ratnaprabha",
  "Gaurav Agarwal",
  "farooq sheikh",
  "Yogendra zala",
  "Vijay Deosaria",
  "Sarita",
  "Swarup",
  "Saurabh Biyani",
  "S.Shetty",
  "Ajay Bisht",
  "BOLLAM Manjunath",
  "Huzefa",
  "Kaushik Patel",
  "Aashish Kumar",
  "Govinda rathi",
  "sunil chirdia",
  "Hershall singh Thakur",
  "MRINAL BOSE",
  "Jayesh",
  "Prad",
  "ALOK SINGH KANDARI",
  "Subingyan Mahakud",
  "ankit popat shinde",
  "Yash Bajaj",
  "Amarpal Singh Singh",
  "Harin reddy",
  "Mudit",
  "Manish Sanodiya",
  "Simer bhatia",
  "Deepak Chandra",
  "RAKESH j TIKAWALA",
  "Arvind Balan",
  "Akshay Patel",
  "Ritesh mor",
  "Mohit Yadav",
  "Vishu",
  "Dhruv Paliwal",
  "Minakshi Goyal",
  "Nitin kharabe",
  "Tushar shah",
  "Shazli Saad",
  "Vishal Jaju",
  "Vipin",
  "Ashutosh Agarwal",
  "Ravi Chowdhary",
  "Swapanil Patil",
  "Raja",
  "Vishal Dobariya",
  "Nishant",
  "Navin Kumar",
  "Yogesh Jangam",
  "Deep kumar",
  "Aniz",
  "Vadiraja Bhatt",
  "Atul Mahamunkar",
  "Siddhartha Jain",
  "Koustuv Paul",
  "OP ROY",
  "Sanjay Rastogi",
  "Tapas manvar",
  "Nilaya jain",
  "Vatshal",
  "Hemant Patel",
  "Mansi",
  "Jivitesh",
  "Ujjwal seth",
  "Manav",
  "Manish Jindal",
  "Abhijit Jayale",
  "Nimish Rastogi",
  "Sabbir Gani",
  "Sharat Bhuyan",
  "Raghav Dhir",
  "Surya Prakash",
  "Shivendra Pratap Singh Bisht",
  "Vipin patni",
  "Jitendra Chaturvedi",
  "Shubham Jain",
  "Shambhuraj  Deshmukh",
  "Gaurav Singh",
  "Avjot Singh",
  "Anjana Chauhan",
  "Sumit Subhash Pingale",
  "Ashutosh agrawal",
  "Brinal",
  "Yogiraj",
  "Anbarashan.M",
  "Manika",
  "Milind Bhajan",
  "Vinodh gunakala",
  "ABHISHEK RAMESH",
  "VINAY SHARMA",
  "Ashish Sonone",
  "NILESH YADAV",
  "M Siddiqui",
  "Pankaj Garg",
  "Akul Agarwal",
  "Manish Goyal",
  "Rajat Baddi",
  "ANAND KUMAR GUPTA",
  "Dr Raj Kumar",
  "Rakesh khandelwal",
  "Pawan Gupta",
  "Suraj",
  "Dixit",
  "Subhasis Samal",
  "Pranav Goyal",
  "Punitkumar Patel",
  "Akkki abs",
  "Mayush Garg",
  "Hddjk dhdj dhdh",
  "Abhishek Shukla",
  "Prabhat Yadav",
  "Onkar Joshi",
  "Rakesh Agarwal",
  "Sharad Palande",
  "Sameer",
  "Sukhvinder singh",
  "Anand Kummaru",
  "Satpal Yadav",
  "Sandeep purle",
  "Kritarth Roy",
  "Chirag Sharma",
  "sAncHit gaRg",
  "Somashekhar",
  "Sudip JAISWAL",
  "Shantanu Dilip Pingale",
  "Rajan Batra",
  "Udesh Asrani",
  "Kumar Saurav",
  "Shashidhar cg",
  "Harpinder Singh",
  "Angad",
  "Sharvan Modi",
  "Jannette Sadhu",
  "Bhavesh Garg",
  "Dhawal",
  "Prakhar Chaturvedi",
  "Vinod Kumar Tiwari",
  "Amit Magdum",
  "Dear User",
  "Brajesh sharma",
  "Vijay N D",
  "Pavan GR",
  "Shamkant",
  "Sudeep Chandhok",
  "Goverdhan",
  "Neelmadhab",
  "Yash praveen bohra",
  "Abhishek Goel",
  "Devavrat Purkar",
  "Dhanrajsinh",
  "Swapnil Patil",
  "Keval Tilavat",
  "SACHIN BODAKE",
  "Shrenik",
  "Neev patel",
  "Aves",
  "Pranshu Goyal",
  "abhishek nautiyal",
  "Sanajay Tiwari",
  "Kalpesh PRAJAPATI",
  "Pradnyesh buva",
  "Mohit Tiwari",
  "Tajinder Singh",
  "Ameya",
  "Kaustubh Manjure",
  "Pratik Gomase",
  "Kulbhushan Sonawane",
  "Nitish Raj",
  "Anil Gupta",
  "Mohammed Saad",
  "Sneh",
  "Aritrik Das",
  "Vishesh",
  "Shreyans Kumar",
  "Yusuf Tabrez",
  "Dhruv Deshwal",
  "Basil Dawre",
  "Anthony Kiriba",
  "Abdul Sattar Farook Dharodia",
  "Sai Borewad",
  "Bhashar Gaur",
  "tahet",
  "Parveen Kumar",
  "Purushartha",
  "Sohel shah",
  "Rakesh Bagaria",
  "Shashank Gadia",
  "Jyoti Bala",
  "Nikhil Chaskar",
  "Honey",
  "VAIBHAV SINGH CHANDEL",
  "Sarthak Goel",
  "janardan ajgaonkar",
  "Piyush Dubey",
  "Divpreet kaur",
  "Vishwajeet Datta Alse",
  "Madan Sirdesai",
  "tanraj singh",
  "MAYUR GAWADE",
  "Saket Malhotra",
  "Dheerendra Singh",
  "Krishna K Jadav",
  "Tikendra bhoi",
  "Yogesh Agrawal",
  "Fuzail Mohammed",
  "Bhuva nishit",
  "manjesh",
  "Kanwaljit Singh",
  "Biswajit Mondal",
  "K S Chauhan",
  "Yaspalsinh Jadeja",
  "Suryakanta Pradhan",
  "Sumit Sinha",
  "Nootan R",
  "Pratik Dhut",
  "Kumar A",
  "Tushar Mishra",
  "Niharika Singh",
  "Manthan patel",
  "Aitik",
  "Swapnil Deokate",
  "Nitin khatana",
  "V I D Ranjan",
  "kunal vats",
  "Tushar S. Bhange",
  "veerabhadra Petli",
  "Rushikesh Lende",
  "Kaushalendra Singh",
  "Hukum Chandra",
  "Dilip",
  "Raju",
  "Mithun",
  "Sumit yadav",
  "Vaibhav Awghate",
  "Sita Ram Choudhary",
  "Akash Joshi",
  "Hitesh Parghi",
  "Robin Dabas",
];
const topCitiesInIndia = [
  "Ahmedabad",
  "Bengaluru",
  "Chennai",
  "Delhi",
  "Hyderabad",
  "Kolkata",
  "Mumbai",
  "Pune",
  "Surat",
  "Jaipur",
  "Lucknow",
  "Kanpur",
  "Nagpur",
  "Indore",
  "Chandigarh",
  "Vadodara",
  "Coimbatore",
  "Patna",
  "Visakhapatnam",
  "Bhopal",
  "Agra",
  "Navi Mumbai",
  "Ranchi",
  "Faridabad",
  "Meerut",
  "Ludhiana",
  "Gurugram",
  "Noida",
  "Vijayawada",
  "Guwahati",
  "Kochi",
  "Madurai",
  "Chandrapur",
  "Aurangabad",
  "Rajkot",
  "Mysuru",
  "Dhanbad",
  "Jabalpur",
  "Jammu",
  "Thane",
  "Bhubaneswar",
  "Howrah",
  "Udaipur",
  "Bikaner",
  "Shimla",
  "Jodhpur",
  "Nagapattinam",
  "Bhilai",
  "Amritsar",
  "Jalandhar",
  "Vellore",
  "Haridwar",
  "Gwalior",
  "Raipur",
  "Siliguri",
  "Trichy",
  "Rourkela",
  "Kollam",
  "Panaji",
  "Patiala",
  "Pondicherry",
  "Tirunelveli",
  "Nanded",
  "Solapur",
  "Thiruvananthapuram",
  "Mangalore",
  "Erode",
  "Kolhapur",
  "Vishakhapatnam",
  "Aligarh",
  "Sangli",
  "Dibrugarh",
  "Muzaffarpur",
  "Bilaspur",
  "Alwar",
  "Chittoor",
  "Haldwani",
  "Srinagar",
  "Rajahmundry",
  "Jammu",
  "Shimoga",
  "Hosur",
  "Firozabad",
  "Bharuch",
  "Kottayam",
  "Kota",
  "Satna",
  "Dehradun",
  "Bareilly",
  "Cuttack",
  "Muzaffarpur",
  "Nellore",
  "Ratlam",
  "Tirupur",
  "Tirunelveli",
  "Agartala",
  "Vapi",
  "Moradabad",
  "Tiruvallur",
  "Warangal",
  "Durgapur",
  "Mysuru",
  "Puducherry",
  "Bhubaneswar",
  "Udupi",
  "Belgaum",
  "Bilaspur",
  "Bengaluru",
  "Kochi",
  "Chandrapur",
  "Fatehabad",
  "Anantapur",
  "Madurai",
  "Muzaffarpur",
  "Latur",
  "Mangalore",
  "Shirdi",
  "Kanchipuram",
  "Navi Mumbai",
  "Palakkad",
  "Madhubani",
  "Kakinada",
  "Surat",
  "Bhopal",
  "Gurgaon",
  "Mysore",
  "Coimbatore",
  "Bilaspur",
  "Muzaffarpur",
  "Madhya Pradesh",
  "Guwahati",
  "Raipur",
  "Patna",
  "Vijayawada",
  "Kolkata",
  "Cuttack",
  "Nagapattinam",
  "Bhubaneswar",
  "Madhya Pradesh",
  "Nagaland",
  "Amritsar",
  "Bhubaneshwar",
  "Solapur",
  "Pune",
  "Bihar",
  "Chennai",
  "Vishakhapatnam",
  "Bengaluru",
  "Haldwani",
  "Surat",
  "Ranchi",
  "Kochi",
  "Shimla",
  "Bikaner",
  "Jalandhar",
  "Mysuru",
  "Madhubani",
  "Chennai",
  "Patiala",
  "Raipur",
  "Vellore",
  "Haridwar",
  "Vadodara",
  "Bhubaneswar",
  "Nagpur",
  "Chandigarh",
  "Pune",
  "Bangalore",
  "Agra",
  "Bhopal",
  "Dhanbad",
  "Bilaspur",
  "Kanpur",
  "Bhubaneswar",
  "Mysuru",
  "Srinagar",
  "Kochi",
  "Dehradun",
  "Vijayawada",
  "Siliguri",
  "Rourkela",
  "Gurugram",
  "Jammu",
  "Mangalore",
  "Faridabad",
  "Nagapattinam",
  "Puducherry",
  "Ludhiana",
  "Cuttack",
  "Udaipur",
  "Baroda",
  "Dibrugarh",
  "Bhopal",
  "Aligarh",
  "Aurangabad",
  "Rajkot",
  "Amritsar",
  "Indore",
  "Patna",
  "Mangalore",
  "Mumbai",
  "Guwahati",
  "Chandigarh",
  "Nagpur",
  "Coimbatore",
  "Gurgaon",
  "Vadodara",
  "Surat",
  "Indore",
  "Meerut",
  "Agra",
  "Bengaluru",
  "Patiala",
  "Vijayawada",
  "Bhopal",
  "Jodhpur",
  "Bhubaneswar",
  "Chennai",
  "Noida",
  "Mumbai",
  "Faridabad",
  "Siliguri",
  "Bareilly",
  "Srinagar",
  "Panaji",
  "Solapur",
  "Kolkata",
  "Bhopal",
  "Amritsar",
  "Thane",
  "Vapi",
  "Madurai",
  "Rajkot",
  "Surat",
  "Kochi",
  "Bhubaneswar",
  "Bengaluru",
  "Mumbai",
  "Dhanbad",
  "Bhilai",
  "Barpeta",
  "Patiala",
  "Raipur",
  "Ranchi",
  "Jabalpur",
  "Kottayam",
  "Chandigarh",
  "Bhubaneswar",
  "Vishakhapatnam",
  "Jammu",
  "Tirunelveli",
  "Mysore",
  "Udaipur",
  "Ambala",
  "Aurangabad",
  "Solapur",
  "Jabalpur",
  "Nagpur",
  "Chennai",
  "Navi Mumbai",
  "Vellore",
  "Rourkela",
  "Tirupati",
  "Vadodara",
  "Indore",
  "Shimla",
  "Amritsar",
  "Puducherry",
  "Bilaspur",
  "Pune",
  "Srinagar",
  "Mangalore",
  "Thane",
  "Chandrapur",
  "Bengaluru",
  "Cuttack",
  "Bihar",
  "Noida",
  "Raipur",
];
function Webinarhomepage() {
  const navigate = useNavigate();
  const [webinarData, setWebinarData] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [userData, setUserData] = useState(null);
  function showToast() {
    const toast = document.getElementById("toast-simple");
    if (toast) {
      toast.classList.add("show");
      setTimeout(() => {
        toast.classList.remove("show");
      }, 4000);
    }
  }
  function getRandomTimeAgo() {
    const isHours = Math.random() > 0.5;
    if (isHours) {
      const hours = Math.floor(Math.random() * 23) + 1; // 1 to 23
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else {
      const minutes = Math.floor(Math.random() * 59) + 1; // 1 to 59
      return `${minutes} min${minutes > 1 ? "s" : ""} ago`;
    }
  }

  const scheduleNextJoin = () => {
    let delay = Math.floor(Math.random() * (35000 - 5000 + 1)) + 5000;
    let time = getRandomTimeAgo();
    setTimeout(() => {
      const randomIndex = Math.floor(Math.random() * userArray?.length);
      const randomUser = userArray[randomIndex];
      const randomCityIndex = Math.floor(
        Math.random() * topCitiesInIndia?.length
      );
      const randomCity = topCitiesInIndia[randomCityIndex];
      setUserData({ randomCity, randomUser, time });

      showToast();

      scheduleNextJoin();
    }, delay);
  };
  useEffect(() => {
    scheduleNextJoin();
  }, []);

  const ScrollToTopButton = () => {
    const element = document.getElementById("targetElementId");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    // window.scrollTo({ top: 380, behavior: "smooth" });
  };

  const getDayFromDate = (datestr) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const date = DateTime.fromISO(datestr, { zone: "Asia/Kolkata" });

    if (date.isValid) {
      return days[date.weekday % 7].toUpperCase(); // Luxon weekday: 1 (Monday) to 7 (Sunday)
    } else {
      return "";
    }
  };

  const toggleDescription = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  useEffect(() => {
    performRequest("GET", "/webinar/getWebinar/")
      .then((res) => {
        if (res.status === 200) {
          setWebinarData(res.data.webinar);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  const discounted = query?.get("discounted");
  const token = query?.get("token");

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>
          Zero to Advanced Hydroponic Webinar | Start Your Agri-Business
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Join India's #1 Hydroponic Webinar led by Shark Tank featured CEO. Learn how to build a tax-free, scalable agri-business from scratch — even with zero experience!"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://alpha.kryzen.com/hydroponic-webinar"
        />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Zero to Advanced Hydroponic Webinar"
        />
        <meta
          property="og:description"
          content="From zero knowledge to expert! Attend India's top-rated hydroponics webinar & learn how to build a profitable, tax-free farming business."
        />
        <meta
          property="og:url"
          content="https://alpha.kryzen.com/hydroponic-webinar"
        />
        <meta
          property="og:image"
          content="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/FHHCahydrobuildcourse1.png"
        />
        <meta
          name="keywords"
          content="hydroponic webinar, hydroponics training India, agriculture business, tax-free farming, hydroponic masterclass, commercial farming, grow vegetables without soil"
        />
      </Helmet>
      <div className="page">
        <div className="page-wrapper">
          <div style={{ minHeight: "80vh" }}>
            <div className="page-body">
              <div className="container-xl">
                <div className="section text-center my-4 py-4">
                  <div className="text-center border p-3 mt-4">
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="">
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: 0,
                              paddingBottom: "56.27198%",
                            }}
                          >
                            <iframe
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                              }}
                              width="500"
                              height="294"
                              src="https://www.youtube.com/embed/W75Jfxfe7SQ?&theme=dark&autohide=2&modestbranding=1&showinfo=0&rel=0"
                              frameBorder="1"
                              allowFullScreen
                              title="YouTube Video"
                            ></iframe>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6  col-sm-12 d-flex align-items-center justify-content-center">
                        <div className="">
                          <h1 className="hero-title aos-init aos-animate m-0 display-5 fw-bold">
                            ZERO TO ADVANCED HYDROPONIC WEBINAR!!!
                          </h1>
                          <h2 className="m-0 p-0">
                            From the makers of Hydroponic Masterclass <br />{" "}
                            India's Most enrolled Hydroponic Training Program.
                          </h2>
                          <div className="text-center my-2">
                            <button
                              onClick={ScrollToTopButton}
                              className="btn btn-indigo btn-lg"
                            >
                              🖥️ Book Your Spot Now!
                            </button>
                          </div>
                          <h3>
                            Designed for you to Start an Agriculture Business
                            but Have ZERO Experience!
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row">
                    <div className="col-md-3 p-2">
                      <div className="card p-3">
                        <h3>
                          India's Highest Numbers of Hydroponic Farm Site
                          Inspections & Actual Constructions!
                        </h3>
                      </div>
                    </div>
                    <div className="col-md-3 p-2">
                      <div className="card p-3">
                        <h3>
                          India's Largest online as well as offline Hydroponic
                          Farming Community Developer!
                        </h3>
                      </div>
                    </div>
                    <div className="col-md-3 p-2">
                      <div className="card p-3">
                        <h3>
                          India's First 100% Hi-Tech Enabled Eco-system Partner
                          with Price-Watcher & Contract farming!
                        </h3>
                      </div>
                    </div>
                    <div className="col-md-3 p-2">
                      <div className="card p-3">
                        <h3>
                          India's First Agri-Business Model Scruttenised by 50+
                          CA, 5+ Sharks on National Television!
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="section text-center my-4 py-4"
                  id="targetElementId"
                >
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      UPCOMING WEBINARS!🔥
                    </h2>

                    <h3 className="section-description m-0 p-0">
                      {/* <img
                        className="p-2"
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/d5cAUhm111.png"
                        alt=""
                        width={"12%"}
                      />{" "}
                      <br /> */}
                      Join and Become Like The Top 1% Successful hydroponic
                      grower! 📈
                    </h3>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-12 col-sm-12 py-2">
                      <div className="row row-cards g-4">
                        {webinarData?.length > 0 ? (
                          webinarData.map((item, index) => (
                            <div
                              key={index}
                              className="col-12 col-sm-6 col-md-4 col-lg-4 mb-4"
                            >
                              <div
                                className={`card h-100 d-flex flex-column justify-content-between ${
                                  item.webinarStatus !== "upcoming"
                                    ? "cursor-not-allowed border border-danger"
                                    : ""
                                }`}
                                style={{
                                  filter:
                                    item.webinarStatus !== "upcoming"
                                      ? "blur(1px) brightness(0.9)"
                                      : "none",
                                  pointerEvents:
                                    item.webinarStatus !== "upcoming"
                                      ? "none"
                                      : "auto",
                                  transition: "filter 0.3s ease",
                                }}
                              >
                                <div style={{ position: "relative" }}>
                                  <div
                                    className={
                                      getDayFromDate(item.webinarDate) ===
                                      "SATURDAY"
                                        ? "ribbon fs-4 bg-green-lt"
                                        : "ribbon fs-4 bg-blue-lt"
                                    }
                                  >
                                    {getDayFromDate(item.webinarDate) ===
                                    "SATURDAY"
                                      ? "HINDI"
                                      : "ENGLISH"}
                                  </div>

                                  {getDayFromDate(item.webinarDate) ===
                                    "FRIDAY" && (
                                    <LazyImageComponent
                                      src={fridayWebinar}
                                      alt={item.webinarName}
                                      className="card-img-top"
                                      style={{
                                        height: "250px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}
                                  {getDayFromDate(item.webinarDate) ===
                                    "SATURDAY" && (
                                    <LazyImageComponent
                                      src={saturdayWebinar}
                                      alt={item.webinarName}
                                      className="card-img-top"
                                      style={{
                                        height: "250px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}
                                  {getDayFromDate(item.webinarDate) ===
                                    "SUNDAY" && (
                                    <LazyImageComponent
                                      src={sundayWebinar}
                                      alt={item.webinarName}
                                      className="card-img-top"
                                      style={{
                                        height: "250px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )}
                                </div>

                                <div className="card-body d-flex flex-column">
                                  <h3 className="card-title text-black fw-bold m-0 p-0">
                                    {item.webinarName}
                                  </h3>
                                </div>

                                <div className="card-footer text-center">
                                  <h2>
                                    🗓️ {item.webinarDate} |{" "}
                                    {item.webinarDate
                                      ? getDayFromDate(item.webinarDate)
                                      : ""}{" "}
                                    <br />
                                    🕒 {item.webinarStartTime} -{" "}
                                    {getDayFromDate(item.webinarDate) ===
                                    "FRIDAY"
                                      ? "9:30 PM"
                                      : getDayFromDate(item.webinarDate) ===
                                        "SATURDAY"
                                      ? "1:30 PM"
                                      : "4:30 PM"}
                                  </h2>
                                  <div>
                                    {
                                      <WebinarCountdown
                                        webinarDate={item?.webinarDate}
                                        webinarStartTime={
                                          item?.webinarStartTime
                                        }
                                      />
                                    }
                                  </div>
                                  <div>
                                    <img
                                      className="my-2"
                                      width={"70%"}
                                      src={webinarPrice}
                                      alt="Webiar Price"
                                    />
                                  </div>
                                  <button
                                    onClick={() => {
                                      if (item.webinarStatus !== "upcoming")
                                        return;

                                      const basePath = `/hm-webinar-order/${item.id}`;
                                      const queryParams =
                                        discounted && token
                                          ? `?discounted=true&token=${token}&webinar=true`
                                          : "";

                                      navigate(`${basePath}${queryParams}`);
                                    }}
                                    className="btn mx-1 mt-2 btn-primary"
                                    type="primary"
                                    disabled={item.webinarStatus !== "upcoming"}
                                  >
                                    BOOK YOUR SPOT
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className="text-muted">No data available</p>
                        )}
                      </div>

                      {/* <div className="col-md-12 col-lg-12 col-sm-12 py-2">
                        <div className="card">
                          <Pagination
                            page={page}
                            setPage={setPage}
                            totalPages={totalPages}
                            pageDatalength={webinarData?.length}
                            showPage={showPage}
                            setShowPage={setShowPage}
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      WHAT HAPPENS WHEN YOU JOIN?
                    </h2>
                    <h3 className="section-description m-0 p-0">
                      {" "}
                      You unlock secrets to create 100% TAX-FREE generational
                      wealth from farming. 💰
                    </h3>
                  </div>

                  <div className="row row-deck text-center">
                    <div className="col-md-4 my-2">
                      <div className="card bg-primary-lt">
                        <div className="card-body">
                          <img
                            width={"60%"}
                            src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/veyzVhm3.png"
                            alt="Hydroponic Farming"
                          />

                          <h3 className="card-title">UNLOCK SECRETS</h3>
                          <p className="text-secondary">
                            You learn how to utilize any barren land, and
                            generate wealth out of it with soil-less farming
                            operations.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-3">
                      <div className="card bg-primary-lt">
                        <div className="card-body">
                          <h3 className="card-title">HYDROPONIC BLUEPRINT</h3>
                          <p className="text-secondary">
                            Learn the bluprint of building commercially
                            successful hydroponic business.
                          </p>
                        </div>
                      </div>
                    </div> */}

                    <div className="col-md-4 my-2">
                      <div className="card bg-primary-lt">
                        <div className="card-body">
                          <img
                            width={"60%"}
                            src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/hMZjdhm1.png"
                            alt="Webinar users"
                          />
                          <h3 className="card-title">
                            MORE PROFIT,MORE FREEDOM
                          </h3>
                          <p className="text-secondary">
                            Knowledge of 10 years, From basics to D learning
                            Jampacked in most curated and easy to grasp format.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2">
                      <div className="card bg-primary-lt">
                        <div className="card-body">
                          <img
                            width={"60%"}
                            src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Gt4nyhm2.png"
                            alt="How to start hydroponic farming"
                          />
                          <h3 className="card-title">REVENUE & SCALE</h3>
                          <p className="text-secondary">
                            The secret KPI indices that help you build
                            foundation you need to build scalling up hydroponic
                            business.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      SUDHIR DEVKAR, FOUNDER & CEO KBPL
                    </h2>
                    <h3 className="section-description m-0 p-0">
                      {" "}
                      👉🏽 Featured on Shark Tank India | 150+ Successful Farm
                      Projects
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 d-flex align-items-center justify-content-center">
                      <img
                        className="border p-2"
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/FHHCahydrobuildcourse1.png"
                        alt="Kryzen with shark tank India"
                        width={"95%"}
                      />
                    </div>
                    <div className="col-lg-6 p-4 px-lg-0">
                      <p>
                        Trained over 70,000+ People about hydroponics in Last 6
                        Years
                      </p>

                      <p>
                        I studied in Mumbai and then finished my engineering in
                        Bangalore. I have worked for big companies like Nokia,
                        Sapient, and Collpoll. For quite some time, I have been
                        successfully growing & enjoying nutritious greens by
                        applying the hydroponic vertical farming technique. Here
                        I am sharing my knowledge & skills, which I acquired
                        through spending so many hours of research, experiments,
                        & mistakes, so that you can avoid all those hassles &
                        have a successful, growing experience in a very short
                        amount of time.
                      </p>
                      <p>50,000+ People Rated Kryzen with 4.9 Stars</p>

                      <div className="row row-deck text-center">
                        <div className="col-md-4">
                          <div className="card bg-primary-lt m-2 p-2">
                            <p>
                              10 Years of practical know-how Experience in
                              Hydroponics.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card bg-primary-lt m-2 p-2">
                            <p>
                              60 Thousands people trained with Hydroponic
                              Masterclass.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card bg-primary-lt m-2 p-2">
                            <p>
                              500+ Seminars & Public Talks in various countries
                              on Hydroponics..
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card bg-primary-lt m-2 p-2">
                            <p>
                              100+ Active Hydroponic farms across the world
                              constructed.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card bg-primary-lt m-2 p-2">
                            <p>
                              500+ People Practically Trained for commercial
                              hydroponic famring.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card bg-primary-lt m-2 p-2">
                            <p>
                              160+ Team size, Runs India's largest hydroponic
                              company.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      RIGHT SYSTEMS, RIGHT STRATEGIES, RIGHT PARTNERS
                    </h2>
                    <h3 className="section-description my-0 p-0">
                      {" "}
                      Backed by industry leaders, Designed for greartness!
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-3 col-sm-6">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/xkEwFhm41.png"
                        alt="Horty Daily"
                      />
                    </div>

                    <div className="col-md-3 col-sm-6">
                      <img
                        width="60%"
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Okdrahm48.jpg"
                        alt="Divya Marathi"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Foizfhm45.png"
                        alt="NBT"
                      />
                    </div>
                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/gYvl6hm43.png"
                        alt="Hindustan Times"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/XIAtDhm47.png"
                        alt="Dainik Bhaskar"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/wZd3Phm44.png"
                        alt="Financial Times"
                      />
                    </div>
                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/Pvm5Vhm49.png"
                        alt="Loksatta"
                      />
                    </div>

                    <div className="col-md-3 d-flex justify-content-center">
                      <img
                        width={"60%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/EhnJohm42.png"
                        alt="Times of India"
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-center d-flex justify-content-center">
                    <div className="col-md-6">
                      <img
                        width={"90%"}
                        src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/X2gZhbackedbyindustryleaders.png"
                        alt="Backend By"
                      />
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center card bg-primary-lt p-6">
                    <h1 className="hero-title aos-init aos-animate m-0 display-4 fw-bold">
                      Join now and become part of the top 1% growers! <br />{" "}
                      <i>before it's too late!</i>
                    </h1>
                    {/* <h2 className="m-0 p-0">
                    OFFER UNTIL STOPWATCH HITS ZERO!
                      Join and Become Like The Top 1% Successful hydroponic
                      enthusiasts Before its too late...
                    </h2> */}
                    <hr className="my-2" />
                    <h2>3 REASONS TO JOIN THIS WEBINAR TODAY!</h2>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="card card bg-primary-lt p-4 m-2">
                          <h2 className="m-0 p-0">01.</h2>
                          <h3>
                            Agricuture is the only Industry which will give you
                            100X returns on the Input.
                          </h3>
                          <p>You just need to know to manage inputs.</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card card bg-primary-lt p-4 m-2">
                          <h2 className="m-0 p-0">02.</h2>
                          <h3>
                            Agricuture is the only Industry which will always
                            have products that are in demand.
                          </h3>
                          <p>
                            You just need to know what to grow at right time.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card card bg-primary-lt p-4 m-2">
                          <h2 className="m-0 p-0">03.</h2>
                          <h3>
                            Agricuture is the only Industry Where you get 100%
                            tax free money.
                          </h3>
                          <p>You just need to know how to manage cashflow.</p>
                        </div>
                      </div>
                    </div>
                    <div className="text-center my-6">
                      <h1 onClick={ScrollToTopButton} className="btn">
                        REGISTER NOW ONLY AT ₹299/-
                      </h1>
                      <p>
                        Learn from the Industry Leaders! Biggest Hydroponic
                        Company, Largest Team size, Highest Number of Projects,
                        Biggest community of growers.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="section text-center my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      TESTIMONIALS
                    </h2>
                    <h3 className="section-description my-0 p-0">
                      {" "}
                      What people say about webinar?
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “Before this webinar, I didn’t even know where to
                            begin. Now I’ve learned enough to set up my own
                            leafy greens farm. Everything was explained so
                            simply!”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Ravi Sharma, Jaipur, Rajasthan</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4  my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “The business model shared in this session is gold.
                            I never imagined barren land on the outskirts of
                            Pune could generate this much monthly income.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3>Pooja Patil, Pune, Maharashtra</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “I'm a software engineer by profession, but always
                            wanted a side business. This webinar showed me a
                            real, tax-free and scalable way to invest in
                            agriculture.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3> Amit Verma, Bengaluru, Karnataka</h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “This is not just theory. They shared actual ROI,
                            subsidy options, and even connected me with a farm
                            visit. It felt like a roadmap, not just a class.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3> Sonal Mehta, Ahmedabad, Gujarat</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “I joined out of curiosity but got so much value in
                            just 2 hours. Now I’m in talks with Kryzen Biotech
                            to start a commercial setup in Kerala.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3> Mohammed Aslam, Kozhikode, Kerala</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2 p-2">
                      <div className="col-md-12 card card-link card-link-pop">
                        <div className="card-body">
                          <p>
                            “The best part is that Sudhir sir has actually built
                            these farms. You can tell he’s not just teaching —
                            he’s done it. That trust factor matters a lot.”
                          </p>
                          <p>⭐⭐⭐⭐⭐</p>
                          <h3> Neha Bansal, New Delhi</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section my-4 py-4">
                  <div className="row text-center my-6">
                    <h2 className="hero-title display-6 fw-bold">FAQ's</h2>
                    <h3 className="section-description my-0 p-0">
                      Questions that asked by most of people.
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div class="accordion" id="accordion-default">
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-1-default"
                              aria-expanded="false"
                            >
                              What is the Zero to D Hydroponic Webinar about?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-1-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div class="accordion-body">
                              This is a 2-hour live session that teaches you how
                              to build a profitable commercial hydroponic
                              farming business from scratch, even if you have no
                              prior experience.
                            </div>
                          </div>
                        </div>

                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-2-default"
                              aria-expanded="false"
                            >
                              Who is this webinar for?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-2-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div class="accordion-body">
                              This webinar is ideal for landowners, working
                              professionals, aspiring agripreneurs, or anyone
                              looking for a second income through agriculture.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-3-default"
                              aria-expanded="false"
                            >
                              Do I need any background in farming or agriculture
                              to attend?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-3-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div class="accordion-body">
                              Not at all! This webinar is designed for absolute
                              beginners as well as those who want to scale their
                              current operations.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-4-default"
                              aria-expanded="false"
                            >
                              What will I learn in this 2-hour session?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-4-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div class="accordion-body">
                              You’ll learn the hydroponic business blueprint,
                              crop selection, setup planning, funding options,
                              government subsidies, marketing strategies, and
                              how to generate consistent revenue.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-5-default"
                              aria-expanded="false"
                            >
                              Is this webinar conducted live or is it
                              pre-recorded?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-5-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div class="accordion-body">
                              It’s a live session conducted 3 times a week
                              (Friday, Saturday, and Sunday) with live Q&A and
                              interaction with the speaker.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-6-default"
                              aria-expanded="false"
                            >
                              Is ₹299 refundable if I don’t like the webinar?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-6-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-default"
                          >
                            <div class="accordion-body">
                              Since this is a special one-time lifetime deal,
                              the fee is refundable but only for limited time
                              before webinar. But we assure full value for your
                              investment.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div class="accordion" id="accordion-second">
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-11-default"
                              aria-expanded="false"
                            >
                              What kind of setup can I build after attending
                              this webinar?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-11-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div class="accordion-body">
                              You’ll be guided on building protected cultivation
                              systems like NFT, DWC, Dutch bucket, and Grow Bag
                              systems suitable for both small and large scale.
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-22-default"
                              aria-expanded="false"
                            >
                              Are there any government schemes or loans
                              available?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-22-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div class="accordion-body">
                              Yes! You’ll learn how to get up to 50% subsidy
                              (NHB/NHM), apply for CGTMSE loans, and tap into
                              the AIF scheme for interest subvention.
                            </div>
                          </div>
                        </div>

                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-33-default"
                              aria-expanded="false"
                            >
                              What support do I get after attending the webinar?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-33-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div class="accordion-body">
                              You can attend a farm visit, consult with our
                              project experts, and choose to join Dd hands-on
                              training.
                            </div>
                          </div>
                        </div>

                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-44-default"
                              aria-expanded="false"
                            >
                              How do I register and get the joining link?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-44-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div class="accordion-body">
                              Click the “Book My Spot Now” button on this page.
                              After payment, you'll receive confirmation via
                              WhatsApp and Email instantly.
                            </div>
                          </div>
                        </div>

                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-55-default"
                              aria-expanded="false"
                            >
                              Are the seats limited?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-55-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div class="accordion-body">
                              Yes. To ensure personal attention and quality, we
                              allow limited seats per session. Book early to
                              avoid missing out.
                            </div>
                          </div>
                        </div>

                        <div class="accordion-item">
                          <div class="accordion-header">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse-66-default"
                              aria-expanded="false"
                            >
                              If I am stuck anywhere, What should I do?
                              <div class="accordion-button-toggle"></div>
                            </button>
                          </div>
                          <div
                            id="collapse-66-default"
                            class="accordion-collapse collapse"
                            data-bs-parent="#accordion-second"
                          >
                            <div class="accordion-body">
                              You can reach out to us on support@kryzen.com or
                              give us a call on +91-9870-424-425
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section text-center card bg-primary-lt my-4 py-4">
                  <div className="row my-6">
                    <h2 className="hero-title display-6 fw-bold">
                      WE ARE ON A MISSION TO HELP 1 MILLION PEOPLE BUILD
                      HYDROPONIC BUSINESS.
                    </h2>
                    <h3 className="section-description my-0 p-0">
                      {" "}
                      AND MAKE INDIA TRUE AGRICULTURE SUPERPOWER IN THE WORLD!
                    </h3>
                  </div>

                  <hr className="my-4 py-4" />
                  <h2 className="hero-title display-6 fw-bold">
                    Be part of the Indian Agriculture Revolution!
                  </h2>
                  <h3>
                    <s>Total Value :₹2,499/-</s>
                  </h3>
                  <h2>
                    <s>Regular Price :₹999/-</s>
                  </h2>
                  <div className="text-center">
                    <button onClick={ScrollToTopButton} className="btn">
                      TODAY'S PRICE:₹299/-
                    </button>
                  </div>
                  <h3>No upsell, no fluff!!!</h3>
                  <p>Just real hydroponic business knowledge that works.</p>
                </div>

                <div className="section text-center my-4 py-4">
                  <img src={webinarDiscount} alt="Discount On Webianr" />

                  <div className="row">
                    <div className="col-md-4">
                      <h2>
                        ✅ OFFER 1: Hydroponic Farm Blueprint (Worth ₹5,999/-) –
                        Absolutely Free
                      </h2>
                      <p>
                        Get instant access to the complete blueprint of a
                        commercially successful hydroponic farm. This
                        step-by-step guide includes farm layout, capital
                        investment plan, equipment list, and operational
                        strategy that can help you recover your full investment
                        in under 1.5 years.
                      </p>
                    </div>
                    <div className="col-md-4">
                      <h2>
                        ✅ OFFER 2: Discount Pass for 8-Day Practical Training
                        (Worth ₹4,999/-)
                      </h2>
                      <p>
                        Unlock a limited-time discount pass to our 8-day,
                        hands-on training program conducted at a fully
                        operational hydroponic farm. This immersive training
                        includes real-time farm experience, crop management
                        drills, sales training, and exposure to commercial-grade
                        farming equipment.
                      </p>
                    </div>
                    <div className="col-md-4">
                      <h2>
                        ✅ OFFER 3: DPR Cheatsheet for Profitable Farming (Worth
                        ₹3,999/-)
                      </h2>
                      <p>
                        Receive a ready-to-use DPR (Detailed Project Report)
                        Cheatsheet with key formulas, templates, and SOPs that
                        simplify farm financial planning and operations. Perfect
                        for preparing for bank loans, investor pitches, and
                        subsidy applications. Ideal for entrepreneurs or
                        investors looking for a scale.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="section text-center bg-secondary-lt my-4 py-4">
                  <img
                    width={"20%"}
                    src="https://d502jbuhuh9wk.cloudfront.net/orgData/65dc4780e4b0b60e6be0bdc1/pages/assets/images/uuhH0hm81.png"
                    alt="100% Money Back Guarantee"
                  />

                  <h2 className="hero-title display-6 fw-bold my-2">
                    BACKED BY 100% RISK FREE REFUND GUARANTEE
                  </h2>
                  <h3 className="section-description my-0 p-0">
                    Get this amazing offer today for just Rs 299, and get a
                    money – back guarantee. Enroll today, By any chance you
                    change your mind, or don't want to go ahead, Reqest Refund
                    24 Hours before webinar & Get your money back.
                  </h3>
                  <div className="text-center my-2">
                    <button onClick={ScrollToTopButton} className="btn">
                      REGISTER NOW AT ₹299/- ONLY!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="toast fade"
            id="toast-simple"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-bs-autohide="false"
          >
            {/* <div className="toast-body">{`Joined the webinar ${userData?.time}`}</div> */}
            <div className="toast-body">
              {`⏰ Another Spot Gone ⏰`} <br />{" "}
              {`${userData?.randomUser}, from ${userData?.randomCity}. Enrolled`}
              {/* <button
                type="button"
                className="ms-2 btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button> */}
            </div>
            {/* <div className="toast-header">
              <span className="avatar avatar-xs me-2">
                <FcManager fontSize={"16px"} />
              </span>
              <strong className="me-auto">{`${userData?.randomUser}, from ${userData?.randomCity}. Enrolled`}</strong>

            </div> */}
          </div>
          <FooterwithoutLogin />
        </div>
      </div>
      <style>{`
        .toast {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #333;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(100%);
  transition: all 1s ease;
  z-index: 9999;
}

.toast.show {
  opacity: 1;
  transform: translateY(0);
}

        `}</style>
    </>
  );
}

export default Webinarhomepage;
